import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { COLORS } from '@next-is-free-monorepo/globals';
import { gray } from '@ant-design/colors';
import { ConfigProvider } from 'antd';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';
import { Board79Provider } from '@virlewood/board-79';


const postHogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
};

// Render the app
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Board79Provider
        config={{
          googlePlaces: {
            apiKey: 'AIzaSyAeqvxyNyGf-Z73FjKingfEHoEsrg6YtF0'
          }
        }}
      >
        <PostHogProvider options={postHogOptions} apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}>
          <ConfigProvider
            theme={{
            token: {
              colorPrimary: COLORS.primary,
              colorBgContainer: COLORS.lightGray
            },
            components: {
              Menu: {
                /* fontWeight: 900,*/
                itemBorderRadius: 2,
                fontSize: 15,
                itemSelectedBg: COLORS.primary,
                itemSelectedColor: COLORS.black,
                itemColor: gray[6]
              },
              Input: {
                colorBgContainer: 'white',
                borderRadius: 8,
                padding: 0,
                controlHeight: 34,
                controlHeightLG: 40,
                fontSizeLG: 15,
                colorBorder: COLORS.slate['200'],
                colorBgContainerDisabled: COLORS.slate['50'],
                colorTextDisabled: COLORS.slate['500'],
                hoverBorderColor: COLORS.slate['400'],
                activeBorderColor: 'black',
                activeShadow: 'none',
                colorTextPlaceholder: COLORS.slate['300'],
              },
              InputNumber: {
                colorBgContainer: 'white',
                addonBg: 'white',
                controlHeight: 34,
                borderRadius: 8,
                colorBorder: COLORS.slate['200'],
                colorBgContainerDisabled: COLORS.slate['50'],
                colorTextDisabled: COLORS.slate['500'],
                hoverBorderColor: COLORS.slate['400'],
                activeBorderColor: 'black',
                activeShadow: 'none',
                colorTextPlaceholder: COLORS.slate['300'],
              },
              Select: {
                colorBgContainer: 'white',
                borderRadiusLG: 8,
                borderRadius: 8,
                controlHeight: 34,
                fontSizeLG: 15,
                colorBorder: COLORS.slate['200'],
                colorTextDisabled: COLORS.slate['500'],
                colorBgContainerDisabled: COLORS.slate['50'],
                colorTextPlaceholder: COLORS.slate['300'],
              },
              DatePicker: {
                colorBgContainer: 'white',
                colorBorder: COLORS.mediumGray
              },
              Form: {
                verticalLabelMargin: 0,
                verticalLabelPadding: 2,
                itemMarginBottom: 12,
                labelColor: gray[6],
                colorTextDescription: COLORS.slate['500'],
              },
              Button: {
                defaultShadow: '',
                primaryShadow: '',
                dangerShadow: '',
                borderRadius: 5,
                lineWidth: 1,
                defaultHoverColor: 'black',
                defaultActiveBg: COLORS.mediumGray,
                defaultActiveColor: COLORS.darkBg,
                defaultColor: 'black',
                defaultBg: 'transparent',
                defaultHoverBg: 'transparent',
                colorPrimaryBg: COLORS.black,
                defaultBorderColor: COLORS.slate['200'], //slate-200
                colorBgContainerDisabled: COLORS.slate['100'], //slate-100
                /*primaryBg: 'red',*/
                borderRadiusLG: 8,
                fontSizeLG: 14,
                colorPrimary: COLORS.blackai,
                colorPrimaryBgHover: COLORS.lightGray,
                colorPrimaryHover: COLORS.darkBg,
                colorPrimaryActive: COLORS.gray,
                borderRadiusSM: 20,
              },
              Table: {
                headerBg: 'white',
                colorPrimaryBg: 'red',
                rowHoverBg: COLORS.slate['50'],
                colorBgContainer: 'white',
                bodySortBg: COLORS.slate['50'],
                headerSortActiveBg: COLORS.slate['50'],
                headerSortHoverBg: COLORS.slate['50'],
                /*   tableBorderRadius: 1,*/

              },
              Slider: {
                trackBg: COLORS.black,
                trackHoverBg: COLORS.gray,
                dotBorderColor: COLORS.black,
                handleColor: COLORS.black,
                handleActiveColor: COLORS.black,
                handleActiveOutlineColor: 'transparent'
              },
              Calendar: {
                colorBgContainer: 'white',
                colorBorder: COLORS.mediumGray,
                itemActiveBg: '#F8FAFC', //tailwind slate-50
                colorSplit: '#F8FAFC'
              },
              Tabs: {
                itemSelectedColor: 'black',
                itemColor: '#64748B',
                itemHoverColor: 'black',
                colorBorder: '#E2E8F0',
              },
              Spin: {
                colorPrimary: COLORS.slate['600'],
              },
              Radio: {
                buttonBg: 'white',
                buttonSolidCheckedBg: COLORS.slate[600],
                buttonSolidCheckedHoverBg: COLORS.slate[500],
                colorPrimaryHover: COLORS.slate[900]
              }
            }
          }}
        >
          <App />
        </ConfigProvider>
      </PostHogProvider>
    </Board79Provider>
    </StrictMode>
  );
}
